import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  Facebook,
  Instagram,
  Mail,
  Phone,
  MapPin,
  CreditCard,
  Truck,
  ShieldCheck,
} from "lucide-react";
import { Link } from "react-router-dom";
import ModalAssessment from "../modalAssessment/modalAssessment";
import { WebSiteSettingsService } from "../../services/webSiteSettigsServices.js";

export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    data: settings,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["siteSettings"],
    queryFn: async () => {
      const res = await WebSiteSettingsService.getAllSettings();
      console.log("DADOS DA API:", res);
      return res;
    },
    select: (data) => {
      if (Array.isArray(data)) {
        return (
          data.find((setting) => setting.is_active) ||
          data[0] ||
          getDefaultSettings()
        );
      }
      return data || getDefaultSettings();
    },
  });

  const getDefaultSettings = () => ({
    footer_frete_gratis: "Frete grátis para compras acima de R$ 499,90",
    footer_parcelas: "Parcele em até 12x sem juros",
    footer_contato_email: "dominusassistencia@gmail.com",
    footer_contato_wpp: "(61) 8449-7981",
    footer_contato_localizacao: "Qs 118 Conjunto 06",
    secondary_color: "#1f2937",
  });

  if (isLoading) {
    return (
      <footer className="bg-gray-900 text-gray-300 py-8">
        <div className="container mx-auto px-4 text-center">
          Carregando configurações...
        </div>
      </footer>
    );
  }

  if (error) {
    console.error("Erro ao carregar configurações do footer:", error);
    // Continua com as configurações padrão
  }
  function formatPhoneNumber(numero) {
    const match = numero.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}${match[3]}-${match[4]}`;
    }
    return numero; // fallback caso não siga o formato
  }
  return (
    <footer
      className="bg-gray-900 text-gray-300"
      style={{ backgroundColor: settings?.secondary_color }}>
      <div className="container mx-auto px-4 py-8">
        {/* Vantagens */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-8 border-b border-gray-800">
          <div className="flex items-center gap-4">
            <Truck className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Frete Grátis</h3>
              <p className="text-sm">
                {settings?.footer_frete_gratis ||
                  "Para compras acima de R$ 499,90"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <CreditCard className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Parcele em até 12x</h3>
              <p className="text-sm">
                {settings?.footer_parcelas || "Parcele suas compras"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <ShieldCheck className="h-10 w-10 text-green-600" />
            <div>
              <h3 className="font-bold">Compra Segura</h3>
              <p className="text-sm">Seus dados protegidos</p>
            </div>
          </div>
        </div>

        {/* Links e Newsletter */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Institucional</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/sobre"
                  className="hover:text-white transition-colors">
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link
                  to="/Termos-de-uso"
                  className="hover:text-white transition-colors">
                  Termos e Condições
                </Link>
              </li>
              <li>
                <Link
                  to="/Politicas-de-privacidade"
                  className="hover:text-white transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link
                  to="/Cookies-e-politicas"
                  className="hover:text-white transition-colors">
                  Política de Cookies
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Ajuda</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/help?section=central"
                  className="hover:text-white transition-colors">
                  Central de Atendimento
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=compra"
                  className="hover:text-white transition-colors">
                  Como Comprar
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=entrega"
                  className="hover:text-white transition-colors">
                  Prazos e Entregas
                </Link>
              </li>
              <li>
                <Link
                  to="/help?section=troca"
                  className="hover:text-white transition-colors">
                  Trocas e Devoluções
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contato</h3>
            <ul className="space-y-4">
              {(settings?.footer_contato_wpp || []).map((contato, index) => (
                <li key={index} className="flex items-start gap-2">
                  <Phone className="h-5 w-5 text-green-600 mt-1" />
                  <a
                    href={`tel:+55${contato.numero.replace(/\D/g, "")}`}
                    className="hover:underline whitespace-nowrap">
                    {contato.numero}{" "}
                    <span className="whitespace-nowrap">
                      ({contato.local?.toUpperCase() || "LOCAL"})
                    </span>
                  </a>
                </li>
              ))}

              <li className="flex items-start gap-2">
                <Mail className="h-5 w-5 text-green-600 mt-1" />
                <a
                  href={`mailto:${
                    settings?.footer_contato_email ||
                    "dominusassistencia@gmail.com"
                  }`}
                  className="hover:underline truncate max-w-full block"
                  title={
                    settings?.footer_contato_email ||
                    "dominusassistencia@gmail.com"
                  }>
                  {settings?.footer_contato_email ||
                    "dominusassistencia@gmail.com"}
                </a>
              </li>

              {(settings?.footer_contato_localizacao || []).map(
                (loc, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <MapPin className="h-5 w-5 text-green-600" />
                    <span>{loc.endereco}</span>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mt-6 mb-4">
              Redes Sociais
            </h3>
            <div className="flex gap-4">
              <Link
                to="/facebook"
                className="hover:text-white transition-colors">
                <Facebook className="h-6 w-6" />
                <span className="sr-only">Facebook</span>
              </Link>
              <a
                href="https://www.instagram.com/dominustech_/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-white transition-colors">
                <Instagram className="h-6 w-6" />
                <span className="sr-only">Instagram</span>
              </a>
            </div>
            <div className="flex gap-2 mt-[4%]">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded transition-colors">
                Avalie Nosso Site
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 pb-4 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Dominus - Todos os direitos
            reservados
          </p>
        </div>
      </div>

      <ModalAssessment
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </footer>
  );
}
